export default __webpack_public_path__ + "static/media/r8.0022a1b1.jpg";